(function($) {
	'use strict';

	$.widget('msv.stickyCta', {
		vars: {
			activateStickyCta: $('.js-show-sticky-cta'),
			hideStickyCta: $('.js-close-sticky-cta'),
			stickyCta: $('.sticky-cta')
		},

		_create: function() {
			var self = this;
			$(window).on('scroll', function() {
				self._events()
			})

			$(window).on('resize', function() {
				self._events();
			});

		},

		_events: function() {
			var self = this;
			var triggerCta = $(this.vars.activateStickyCta).innerHeight() + $(this.vars.activateStickyCta).offset().top;
			var hideCta = $(this.vars.hideStickyCta).offset().top;

			if ($(window).scrollTop() > triggerCta && $(window).scrollTop() < (hideCta - window.innerHeight)) {
				self.vars.stickyCta.addClass('show')
			}
			else {
				self.vars.stickyCta.removeClass('show')
			}
		}
	});

})(jQuery);